@if (isMobile()) {
    <app-mobile-budget
        [loading]="loading"
        [report]="report"
        [company]="company"
        [accordionState]="accordionState"
        (handleChangePeriod)="onChangePeriod($event)"
        (handleChangeComparation)="onChangeComparation($event)"
        (handleResetPeriod)="onResetPeriod()"
        [previewMode]="previewMode"
    ></app-mobile-budget>
} @else {
    <app-desktop-budget
        [loading]="loading"
        [accordionState]="accordionState"
        [report]="report"
        [company]="company"
        (handleChangePeriod)="onChangePeriod($event)"
        (handleChangeComparation)="onChangeComparation($event)"
        (handleResetPeriod)="onResetPeriod()"
        [previewMode]="previewMode"
    ></app-desktop-budget>
}
